/* eslint-disable import/no-default-export */
import React from 'react';

const DescriptionIcon = (props) => (
  <svg width={12} height={11} viewBox="0 0 12 11" {...props}>
    <path
      d="M.75 1.5a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5H.75zm0 3a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5H.75zm0 3a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5H.75zm0 3a.75.75 0 1 1 0-1.5H6a.75.75 0 0 1 0 1.5H.75z"
      fillRule="nonzero"
      fill={props.color || 'currentColor'}
    />
  </svg>
);

export default DescriptionIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/DescriptionIcon.js